module.exports = __webpack_public_path__ + "img/3764695.png";